import React from 'react';
import LiveBlogFAQ from './components/LiveBlogFAQ';

import LiveBlogIntro from './components/LiveBlogIntro';
import EventList from './components/EventList';

const LiveBlog: React.FC = () => {
  return (
    <main className={'live-blog'}>
      <section className={'main-section'}>
        <LiveBlogIntro />
        <EventList />
      </section>
      <LiveBlogFAQ />
    </main>
  );
};

export default LiveBlog;
